import { render, staticRenderFns } from "./DirectDepositNoticeModal.vue?vue&type=template&id=a7fe9c3c&scoped=true"
import script from "./DirectDepositNoticeModal.vue?vue&type=script&lang=ts"
export * from "./DirectDepositNoticeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fe9c3c",
  null
  
)

export default component.exports